import {useEffect, useState} from 'react'

/**
 * 뷰포트 폭. resize 와 브라우저 확대/축소에 반응한다.
 * 렌더 시점에 window.innerWidth 를 한 번만 읽으면 창 크기가 바뀌어도
 * 폰트 크기 등이 갱신되지 않아 레이아웃이 어긋나기 때문에 훅으로 분리했다.
 */
const useWindowWidth = () => {
  const [width, setWidth] = useState(() => window.innerWidth)

  useEffect(() => {
    let frame = 0
    const handleResize = () => {
      cancelAnimationFrame(frame)
      frame = requestAnimationFrame(() => setWidth(window.innerWidth))
    }
    window.addEventListener('resize', handleResize)
    return () => {
      cancelAnimationFrame(frame)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return width
}

export default useWindowWidth
